module.exports = __webpack_public_path__ + "img/citrix.b962eaaf.jpg";